import React from 'react';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';
import Button from '../../../../core/form/Button';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';

const PlacementTestItemHistoryDetail = (props) => (
  <Card
    title="Item details"
    loading={props.fetching}
    actions={<Button icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
  >
    <div>
      <b>Level</b>: <span>{props.placementTestItem.grammarPlacementTestLevel.placementTestLevel.level}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Grammar</b>: <span>{props.placementTestItem.item.grammar.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Text</b>: <span>{props.placementTestItem.item.text}</span>
    </div>
  </Card>
);

PlacementTestItemHistoryDetail.propTypes = {
  fetching: PropTypes.bool,
  placementTestItem: PropTypes.shape({
    grammarPlacementTestLevel: PropTypes.shape({
      placementTestLevel: PropTypes.shape({
        level: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
      grammar: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

PlacementTestItemHistoryDetail.defaultProps = {
  fetching: false,
};

export default PlacementTestItemHistoryDetail;
